module.exports = __webpack_public_path__ + "static/media/23.24f2bce7.png";